// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"4ad84bc97e0e44116de1","655":"43c4a10843c9eb3c7313"}[chunkId] + ".js";
};